import { useMemo } from 'react';
import { DateTimeLocalizationInfo, useDateTimeLocalizationInfo } from '@mews/framework';

export enum AssistantDateFormat {
    DateMedium = 'dd MMM, yyyy',
    Full = 'EEEE, MMM d yyyy, HH:mm',
}

/*
 * Hook for getting localization info for assistant.
 * If you need to add a new format, add it to the enum AssistantDateFormat.
 * If you think this is not the best way of doing this, please let us know, so we could implement it better.
 */
export const useAssistantDateTimeLocalizationInfo = (
    format: AssistantDateFormat = AssistantDateFormat.DateMedium
): DateTimeLocalizationInfo => {
    let localizationInfo = useDateTimeLocalizationInfo();
    localizationInfo = { ...localizationInfo, dateFormat: format };

    return useMemo(() => localizationInfo, [localizationInfo]);
};
